import { ROUTE_TYPE } from '@/constants';
import { hasPriceCalculatorSubscription } from '@/domains/permissions/subscription';
import { buildProtectedRoute } from '@/router/utils/buildProtectedRoute';

const routes = [
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { type: ROUTE_TYPE.public },
    component: () => import('@/views/Infrastructure/MaintenanceView/index.vue'),
  },
  {
    path: '/invitations/:id/acceptance',
    name: 'invitationAcceptance',
    meta: { type: ROUTE_TYPE.private },
    component: () => import('@/views/Invitations/index.vue'),
  },
  {
    path: '/unsubscribe',
    name: 'unsubscribe',
    meta: { type: ROUTE_TYPE.public },
    component: () => import('@/views/UnsubscribingFromEmails/index.vue'),
  },
  buildProtectedRoute({
    path: '/transportation_calculator',
    name: 'transportationCalculator',
    meta: {
      type: ROUTE_TYPE.private,
      permissions: [hasPriceCalculatorSubscription],
      component: () => import('@/views/TransportationCalculatorView/index.vue'),
    },
  }),
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    meta: { type: ROUTE_TYPE.public },
    component: () => import('@/views/NotFoundView/index.vue'),
  },
];

export default routes;
